module.exports = __webpack_public_path__ + "resources/img/cloud_security.48189b93c8f72f4fae62b47b141f476e.png";